import { FormSetting } from '@/form-settings/form-setting';

export class ModelsFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'marca',
            controlType: 'autocomplete-brand',
            label: 'Marca',
            order: 1,
            class: 'lg:w-3/12 w-full',
            required: true,
            options: this.data['brands'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'siglaModello',
            label: 'Sigla Modello',
            controlType: 'textinput',
            class: 'lg:w-3/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'descrizioneModello',
            label: 'Descrizione',
            controlType: 'textinput',
            class: 'lg:w-3/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'enabled',
            controlType: 'slide-toggle',
            label: 'Abilitato',
            default: true,
            order: 1,
            class: 'lg:w-3/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
